<template>
  <Card>
   <AjaxForm route="admin/app/setLearningPageHtml">
     <label>متن صفحه :</label>
     <div class="form-group">
       <label for="textarea_id">html : </label>
       <textarea autocomplete="off" id="textarea_id"
                 placeholder="html راهنما"
                 dir="ltr" rows="8" class="form-control" v-model="data.html" name="content"></textarea>
     </div>
     <div class="form-group">
       <label>css : </label>
       <textarea autocomplete="off" name="css" placeholder="css" rows="8" v-model="data.css" class="form-control" dir="ltr"></textarea>
     </div>
     <div class="row">
       <div class="col-12 col-sm-10 col-md-5 mx-auto my-3">
         <button class="btn btn-info btn-block" type="submit">ویرایش متن</button>
       </div>
     </div>
   </AjaxForm>
  </Card>
</template>

<script>
import Card from "@/components/forms/Card";
import {mapActions} from "vuex";
import Editor from '@tinymce/tinymce-vue'
import {AppApi} from "@/api/AppApi";
import AjaxForm from "@/components/forms/AjaxForm";
export default {
  name: "learningPage",
  components: {AjaxForm, Card,Editor},
  data()
  {
    return{
      data : {},
    }
  },
  mounted()
  {
    this.setPageTitle('تنظیمات صفحه آموزش');
    this.setShowHead(true);
    this.setPageLoading(false);
    this.initPage();
  },
  methods: {
    ...mapActions('app', {
      setPageTitle: 'setPageTitle',
      setPageLoading: 'setPageLoading',
      setShowHead: 'setShowHead'
    }),
    async initPage()
    {
      this.setPageLoading(true);
      const result = await AppApi.getLearningPageHtml();
      if (result.ok)
      {
        this.data = result.html;
      }
      else
        this.error = result.error;

      this.setPageLoading(false);
    }
  }
}
</script>

<style scoped>

</style>